import React, { useEffect, useMemo, useRef, useState } from 'react';

import classNames from 'classnames';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';

import { Popup } from '@shared/ui';

import cls from './Body.module.css';
import { Diagram } from './Diagram/Diagram';
import { Resizer } from './Resizer/Resizer';
import { Table } from './Table/Table';
import { useUpdateAll } from '../../../hooks/useUpdateAll';
import { gantActions } from '../../../store/reducers/gantSlice/gantSlice';
import { positionSelector } from '../../../store/reducers/positionSlice/positionSlice';
import { tableWidthActions } from '../../../store/reducers/tableWidthSlice/tableWidthSlice';

export const Body = ({ stages }) => {
    const dispatch = useDispatch();

    const { settings, firstStageStart } = useSelector((state) => state.gantReducer);
    const [diagramPosition, setDiagramPosition] = useState({ x: 0, y: 0 });
    const diagramRef = useRef(null);

    const { isShowPopup } = useSelector((state) => state.gantReducer);
    const { width } = useSelector((state) => state.tableWidthReducer);

    const nonNullStages = stages.filter((stage) => stage.planned.days_count);

    const isNullStages = !nonNullStages.length;

    const positionsEntities = useSelector(positionSelector.selectEntities);

    const { updateAll } = useUpdateAll();

    useEffect(() => {
        updateAll(positionsEntities);
    }, [settings.isShowMHD]);

    const styles = useMemo(
        () => ({
            gridTemplateColumns: `${width}px 4px 1fr`,
        }),
        [width]
    );

    const handleResize = (newWidth) => {
        dispatch(tableWidthActions.changeWidth(newWidth - 21));
    };

    const scrollDiagram = (
        element = diagramRef.current?.querySelector('[data-date-now="true"]')
    ) => {
        if (!diagramRef) return;

        diagramRef.current?.scroll(0, 0);

        const { x, y } = {
            x: diagramRef.current.offsetLeft,
            y: diagramRef.current.offsetTop,
        };

        let relativeCoordinates = 0;

        if (element) {
            const diagramRect = diagramRef.current.getBoundingClientRect();
            const elementRect = element.getBoundingClientRect();

            relativeCoordinates = elementRect.left - diagramRect.left;
        }

        setDiagramPosition({ x, y });
        diagramRef.current?.scroll(relativeCoordinates - 72, 0);
    };

    return (
        <>
            <div style={styles} className={classNames(cls.Body)}>
                <Popup
                    popupContentClassName={cls.popup}
                    isOpen={isShowPopup}
                    contentText={i18next.t('Gant.Body.return.Popup.text')}
                    onHidePopup={() => dispatch(gantActions.changeShowPopup(false))}
                    type="alert"
                />
                <Table stages={stages} />
                <Resizer onResize={handleResize} scrollDiagram={scrollDiagram} />
                <Diagram
                    firstStageStart={firstStageStart}
                    diagramPosition={diagramPosition}
                    setDiagramPosition={setDiagramPosition}
                    stages={stages}
                    diagramRef={diagramRef}
                    scrollDiagram={scrollDiagram}
                />
            </div>

            {isPlanFact && isNullStages && (
                <div className={cls.zag}>
                    <p>{i18next.t('Gant.Body.return.zag.text')}</p>
                </div>
            )}
        </>
    );
};
